module.exports = __webpack_public_path__ + "flyer_background_berries_066-2c333fad5684192a9197facac566c0fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_berries_066.jpg
// module id = 1606
// module chunks = 1